import { Link } from "react-router-dom";
import { HomeContentContainer } from "../shared/homeContentContainer";
import { HomeNavbar } from "../shared/navbar";
import styles from "./styles.module.scss";
import { Button } from "../shared/button";
import { NotifyMeForm } from "../shared/notifyMeForm";
import { LegalLinks } from "../shared/legalLinks";
import poolImg from "./assets/pool-image-800.jpg";
import propOverviewImgDesktop from "./assets/Pop_Prop.png";
import propOverviewImgMobile from "./assets/Mobile_Pop_Prop.png";
import propAvmImg from "./assets/Pop_avm.png";
import propEquityImg from "./assets/Pop_equity.png";
import { PlayVideoButton } from "../shared/playVideoButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlay } from "@fortawesome/pro-regular-svg-icons";

export function HomePage() {
  return (
    <HomeContentContainer>
      <HomeNavbar />
      <main className={styles.main}>
        <section className={styles.left_section}>
          <h1 className={styles.hero_header}>
            Intelligence <br /> Behind Every <br />{" "}
            <span className={styles.sup_anchor}>
              Address.
              {/* <sup className={styles.header_sup}>TM</sup> */}
            </span>
          </h1>
          <div className={styles.coming_soon_wrapper}>
            <div className={styles.coming_soon_line} />
            <Button secondary className={styles.coming_soon_btn}>
              COMING SOON
            </Button>
          </div>
          <div className={styles.subheader_wrapper}>
            <h2>The new Flueid Pro.</h2>
            <Link to="/promo-video" className={styles.promo_video_link_mobile}>
              <FontAwesomeIcon icon={faCirclePlay} className="txt-primary" size="3x" />
            </Link>
          </div>
          <p className={styles.description}>
            Get ready to discover and analyze properties, engage prospects, and close opportunities faster than ever
            before. Don’t miss the latest features and functionality coming soon to Flueid Pro.
          </p>
          <NotifyMeForm />
          <footer className={styles.footer_desktop}>
            <LegalLinks />
          </footer>
        </section>
        <section className={styles.right_section}>
          <img className={styles.promo_img_desktop} src={poolImg} />
          <div className={styles.promo_img_mobile_wrapper}>
            <img className={styles.promo_img_mobile} src={poolImg} />
          </div>
          <div className={styles.widgets_grid}>
            <img className={styles.prop_overview_img_desktop} src={propOverviewImgDesktop} />
            <img className={styles.prop_overview_img_mobile} src={propOverviewImgMobile} />
            <img className={styles.prop_avm_img} src={propAvmImg} />
            <img className={styles.prop_equity_img} src={propEquityImg} />
          </div>
          <Link to="/promo-video" className={styles.promo_video_link}>
            <PlayVideoButton />
          </Link>
        </section>
      </main>
      <div className={styles.vertical_brand_line}></div>
      <footer className={styles.footer_mobile}>
        <LegalLinks />
      </footer>
    </HomeContentContainer>
  );
}
